import { fixedSpacingValue, spacingValue } from '../../foundations/spacing';
export function resolveMobileValue(isMobileContext, base, mobileOverride) {
    return isMobileContext && mobileOverride != null ? mobileOverride : base;
}
function isDeviceSpacing(value) {
    return typeof value === 'object' && value !== null && 'desktop' in value;
}
function deviceSpacingValue(spacing, isMobileDevice) {
    return fixedSpacingValue(isMobileDevice ? spacing.mobile : spacing.desktop);
}
export function gapStyle(gap, isMobileDevice) {
    if (isDeviceSpacing(gap)) return {
        gap: deviceSpacingValue(gap, isMobileDevice)
    };
    if (typeof gap !== 'object') return {
        gap: spacingValue(gap)
    };
    return {
        rowGap: spacingValue(gap.row),
        columnGap: spacingValue(gap.column)
    };
}
export function paddingStyle(padding, isMobileDevice) {
    if (isDeviceSpacing(padding)) return {
        padding: deviceSpacingValue(padding, isMobileDevice)
    };
    if (typeof padding !== 'object') return {
        padding: spacingValue(padding)
    };
    const { top, right, bottom, left, vertical, horizontal } = padding;
    return {
        paddingTop: spacingValue(top !== null && top !== void 0 ? top : vertical),
        paddingRight: spacingValue(right !== null && right !== void 0 ? right : horizontal),
        paddingBottom: spacingValue(bottom !== null && bottom !== void 0 ? bottom : vertical),
        paddingLeft: spacingValue(left !== null && left !== void 0 ? left : horizontal)
    };
}
